import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { finalize, switchMap, catchError, map, tap, concatMap } from 'rxjs/operators';
import { EMPTY, Observable, from, of } from 'rxjs';

import { LoadingLists } from '../../interfaces/LoadingLists.interfaces';
import { LoadingListService } from '../../services/loading-list.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { LoadingListItemsComponent } from './loading-list-items/loading-list-items.component';
import { Warehouse } from '../../interfaces/Warehouses.interfaces';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ClientsBrands } from '../../services/routing.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Carrier } from '../../interfaces/anagraphic.interfaces';
import { AnagraphicService } from '../../services/anagraphic.service';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { NewLoadingListDialogComponent } from './new-loading-list-dialog/new-loading-list-dialog.component';
import { NotificationService } from '../../services/notification.service';
import { ErrorHelperService } from '../../services/error-helper.service';
import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { LoadingListInvalidateDialogComponent } from './loading-list-invalidate-dialog/loading-list-invalidate-dialog.component';
import {NgxPaginationModule} from 'ngx-pagination';
import { TripService } from '../../services/trip.service';

export enum LoadingListStatus {
  DELETED = 'ELIMINATO',
  DRAFT = 'BOZZA',
  CLOSED = 'CHIUSO',
  PREPARED = 'VALIDATO',
  ARRIVED = 'ARRIVATO',
  ARRIVING = 'IN ARRIVO'
}

@Component({
  selector: 'app-loading-list',
  standalone: true,
  imports: [TranslateModule, CommonModule, RouterModule, LoadingListItemsComponent, FormsModule, NgSelectModule, MatTooltipModule, MatDialogModule, NgxPaginationModule ],
  templateUrl: './loading-list.component.html',
  styleUrls: ['./loading-list.component.scss']
})
export class LoadingListComponent implements OnInit {

  @ViewChild('dateFromInput', { static: false }) dateFromInput?: ElementRef<HTMLInputElement>;
  @ViewChild('dateToInput', { static: false }) dateToInput?: ElementRef<HTMLInputElement>;

  isLoading = false;
  detachingTrip: Record<number, boolean> = {};
  isSearchLoading = false;

  isFiltersCollapsed = false;

  warehouseCodes: string[] = []; 
  warehouses: Warehouse[] = []; 
  filterWarehouse: string | null = null;

  filterWarehouseTo: string | null = null;
  filterWarehouseFrom: string | null = null;

  filterWarehouseInvalid: boolean = false;

  filterStatus = 'ALL_NO_CLOSED';
  filterType = 'ALL_NO_LINE_CHECK';

  searchLoadingListCode = '';
  searchParcelCode = '';

  includeClosed = false; 

  carriers: Carrier[] = [];

  availableStatuses = [
    { value: '',          label: 'TUTTI',     icon: 'fa-circle',      color: '#6c757d' }, // secondary
    { value: 'ALL_NO_CLOSED',   label: 'TUTTI (senza chiusi)',     icon: 'fa-circle',      color: '#9db2c5' }, // secondary
    { value: 'DRAFT',     label: 'BOZZA',     icon: 'fa-pen',             color: '#f57906' }, // warning
    { value: 'PREPARED',  label: 'PREPARATO',  icon: 'fa-circle-check',    color: '#297af5' }, // success
    { value: 'ARRIVED',   label: 'IN ARRIVO/ARRIVATO',  icon: 'fa-circle-down',     color: '#0dcaf0' }, // info 
    { value: 'CLOSED',    label: 'CHIUSO',    icon: 'fa-lock',            color: '#198754' }, // primary
  // { value: 'DELETED',   label: 'ELIMINATO', icon: 'fa-trash',           color: '#dc3545' }  // danger
  ];

//   availableStatuses = [
//   { value: '__HIDE_CLOSED__', label: 'Nascondi chiusi', icon: 'fa-eye-slash', color: '#6c757d', special: true },
//   { value: '', label: 'Mostra chiusi', icon: 'fa-eye', color: '#6c757d', special: true },

//   // poi i tuoi veri stati
//   { value: 'DRAFT', label: 'Bozza', icon: 'fa-pen', color: '#f57906' },
//   { value: 'PREPARED', label: 'Preparato', icon: 'fa-circle-check', color: '#297af5' },
//   { value: 'ARRIVED', label: 'Arrivato', icon: 'fa-circle-down', color: '#0dcaf0' },
//   { value: 'CLOSED', label: 'Chiuso', icon: 'fa-lock', color: '#198754' },
// ];

  availableType = [
    { value: 'ALL_NO_LINE_CHECK', label: 'TUTTI (senza controllo fila)', icons: [
        { icon: 'fa-arrow-up', color: '#9db2c5' },
        { icon: 'fa-arrow-down', color: '#9db2c5' }
      ],
      color: '#9db2c5' },
    { value: '', label: ' TUTTI', icons: [
        { icon: 'fa-arrow-up', color: '#6f42c1' },
        { icon: 'fa-arrow-down', color: '#20c997' }
      ],
      color: '#6c757d' },
    { value: 'DEPARTURE', label: 'PARTENZA', icon: 'fa-arrow-up', color: '#6f42c1' },
    { value: 'ARRIVAL', label: 'ARRIVO', icon: 'fa-arrow-down', color: '#20c997' },
    { value: 'LINE_CHECK', label: 'CONTROLLO FILA', icon: 'fa-list-check', color: '#fd7e14' }
  ];

  dropdownStyles: { [key: string]: any } = {};
  openDropdownId: number | null = null;

  appliedWarehouse: string | null = null;

  selectedDateFrom: Date | null = null;
  selectedDateTo: Date | null = null;
  selectedDateFromStr = '';
  selectedDateToStr = '';

  lists: LoadingLists[] = [];
  filteredLists: LoadingLists[] = [];

  itemsPerPage = 25;
  currentPage = 1;
  pagedLists: LoadingLists[] = [];

  selectedIds = new Set<number>();

  isPrinting = false;
  isExporting = false;

  isDetailVisible = false;
  selectedLoadingList: LoadingLists | null = null;

  summaryTotal = 0;
  summaryDraft = 0;
  summaryValidated = 0;
  summaryClosed = 0;
  summaryDeleted = 0;
  summaryArrived = 0;

totAllLoadedItems = 0;
totAllLoadedWeight = 0;
totAllLoadedVolume = 0;
totAllUnloadedItems = 0;
totAllUnloadedWeight = 0;
totAllUnloadedVolume = 0;

totDraftLoadedItems = 0;
totDraftLoadedWeight = 0;
totDraftLoadedVolume = 0;
totDraftUnloadedItems = 0;
totDraftUnloadedWeight = 0;
totDraftUnloadedVolume = 0;

totValidatedLoadedItems = 0; 
totValidatedLoadedWeight = 0;
totValidatedLoadedVolume = 0;
totValidatedUnloadedItems = 0;
totValidatedUnloadedWeight = 0;
totValidatedUnloadedVolume = 0;

totArrivedLoadedItems = 0;
totArrivedLoadedWeight = 0;
totArrivedLoadedVolume = 0;
totArrivedUnloadedItems = 0;
totArrivedUnloadedWeight = 0;
totArrivedUnloadedVolume = 0;

totClosedLoadedItems = 0;
totClosedLoadedWeight = 0;
totClosedLoadedVolume = 0;
totClosedUnloadedItems = 0;
totClosedUnloadedWeight = 0;
totClosedUnloadedVolume = 0;

totDeletedLoadedItems = 0;
totDeletedLoadedWeight = 0;
totDeletedLoadedVolume = 0;
totDeletedUnloadedItems = 0;
totDeletedUnloadedWeight = 0;
totDeletedUnloadedVolume = 0;


totDraftItems = 0; totDraftWeight = 0; totDraftVolume = 0;
totPreparedItems = 0; totPreparedWeight = 0; totPreparedVolume = 0;
totArrivedItems = 0; totArrivedWeight = 0; totArrivedVolume = 0;
totClosedItems = 0; totClosedWeight = 0; totClosedVolume = 0;


  isReportCollapsed = false;

  
showDeletePopup = false;
deleteTarget: any = null;

deleting = false;

requireDeleteTextConfirm = false;
deleteConfirmText = '';

  constructor(
    private loadingListService: LoadingListService,
    private tripService: TripService,
    private http: HttpClient,
    private anagraphicService: AnagraphicService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private errorHelperService: ErrorHelperService
  ) {}

  ngOnInit(): void {
    this.loadWarehouses();
    this.loadCarriers();

      const todayStr = this.toYyyyMmDd(new Date());
    this.selectedDateFromStr = todayStr;
    this.selectedDateToStr = todayStr;

    //this.search();
  }

  loadWarehouses(): void {
    this.http.get<Warehouse[]>(`${environment.apiUrl}/tracking/warehouses`).subscribe({
      next: (data) => {
        this.warehouses = data;
        const stored = localStorage.getItem('userFunctions');
        if(stored) {
          const parsed = JSON.parse(stored);
          this.warehouseCodes = parsed.warehouses;
          if(this.warehouseCodes != null || this.warehouseCodes != "all") {
            this.warehouses = this.warehouses.filter(w =>
              this.warehouseCodes.includes(w.warehouseCode)
            );  
          } 
          if (this.warehouses.length === 1) {
            this.filterWarehouse = this.warehouses[0].warehouseCode;
          }
        }
      },
      error: (err) => {
        const message = this.errorHelperService.extractBackendMessage(err);
        this.notificationService.error(`Errore: ${message}`);
      }
    });
  }

  loadCarriers(): void {
    this.anagraphicService.loadCarriers().subscribe({
      next: (res) => {
        this.carriers = res;
      },
      error: (err) => {
        const message = this.errorHelperService.extractBackendMessage(err);
        this.notificationService.error(`Errore: ${message}`);
      }
    });
  }

  toggleFiltersCollapsed(): void {
    this.isFiltersCollapsed = !this.isFiltersCollapsed;
  }

  openCreatePopup(): void {
    const dialogRef = this.dialog.open(NewLoadingListDialogComponent, {
      width: '1050px',
      maxWidth: '95vw',
      panelClass: 'app-popup-dialog',
      autoFocus: false,
      data: { mode: 'CREATE', warehouses: this.warehouses, carriers: this.carriers }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) return;
      this.isLoading = true;

      const createRequest = result as any;
      const linkedTripCode: string | null = createRequest?.linkedTripCode ?? null;

      // Raccolgo i warning non bloccanti: il borderò e' comunque creato
      const warnings: string[] = [];
      let attachedToTrip = false;

      this.loadingListService.createLoadingList(createRequest).pipe(
        switchMap((created: any) => {
          const attach$: Observable<unknown> = linkedTripCode
            ? this.tripService.attachLoadingListToTrip({
                loadingListId: created.loadingListId,
                scannedCode: linkedTripCode,
                warehouseCode: createRequest.warehouseCode
              }).pipe(
                tap(() => (attachedToTrip = true)),
                catchError((err) => {
                  warnings.push(`Borderò creato ma non collegato al viaggio: ${this.errorHelperService.extractBackendMessage(err)}`);
                  return of(null);
                })
              )
            : of(null);

          return attach$.pipe(map(() => created));
        }),
        finalize(() => (this.isLoading = false))
      ).subscribe({
        next: (created: any) => {
          warnings.forEach(w => this.notificationService.error(w));
          // Stampa dei documenti di trasporto abbinati (solo se il borderò e' collegato a un viaggio)
          if (attachedToTrip) {
            this.downloadLinkedTransportDocuments(
              [created.loadingListId],
              linkedTripCode,
              [created.loadingListCode ?? String(created.loadingListId)]
            );
          }
          this.search();
        },
        error: (err) => {
          const message = this.errorHelperService.extractBackendMessage(err);
          this.notificationService.error(`Errore: ${message}`);
        }
      });
    });
  }

  detachLoadingListFromTrip(ll: LoadingLists): void {
    if (!ll.loadingListTripCode) return;

    this.detachingTrip[ll.loadingListId] = true;

    this.tripService.detachLoadingListFromTrip({ loadingListId: ll.loadingListId }).subscribe({
      next: () => {
        this.detachingTrip[ll.loadingListId] = false;
        this.search();
      },
      error: (err) => {
        this.detachingTrip[ll.loadingListId] = false;
        const message = this.errorHelperService.extractBackendMessage(err);
        this.notificationService.error(`Errore: ${message}`);
      }
    });
  }



  
shiftSelectedDates(days: number): void {

  const from = this.fromYyyyMmDd(this.selectedDateFromStr) ?? new Date();
  const to   = this.fromYyyyMmDd(this.selectedDateToStr) ?? new Date();

  this.selectedDateFromStr = this.toYyyyMmDd(this.addDays(from, days));
  this.selectedDateToStr   = this.toYyyyMmDd(this.addDays(to, days));

}

  onDateStringsChange(): void {
    this.syncDatesFromDateStrings();
  }

  private addDays(date: Date, days: number): Date {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  }

  private toYyyyMmDd(date: Date): string {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  private fromYyyyMmDd(value: string): Date | null {
    if (!value) return null;
    const [y, m, d] = value.split('-').map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
  }

  private syncDateStringsFromDates(): void {
    if (this.selectedDateFrom) this.selectedDateFromStr = this.toYyyyMmDd(this.selectedDateFrom);
    if (this.selectedDateTo) this.selectedDateToStr = this.toYyyyMmDd(this.selectedDateTo);
  }

  private syncDatesFromDateStrings(): void {
    const from = this.fromYyyyMmDd(this.selectedDateFromStr);
    const to = this.fromYyyyMmDd(this.selectedDateToStr);

    if (from) this.selectedDateFrom = from;
    if (to) this.selectedDateTo = to;
  }

  getFormattedDateFrom(): string {
    return this.selectedDateFrom ? this.formatDate(this.selectedDateFrom) : '';
  }

  getFormattedDateTo(): string {
    return this.selectedDateTo ? this.formatDate(this.selectedDateTo) : '';
  }



  private formatDate(d: Date): string {
    // dd/MM/yyyy
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }



  resetFilters(): void {
    this.filterWarehouse = null;
    this.filterWarehouseTo = null;
    this.filterWarehouseFrom = null;
    this.filterStatus = 'ALL_NO_CLOSED';
    this.filterType = 'ALL_NO_LINE_CHECK';
    this.searchLoadingListCode = '';
    this.searchParcelCode = '';
    const today = new Date();
    this.selectedDateFrom = today;
    this.selectedDateTo = today;

    this.currentPage = 1;
    this.selectedIds.clear();

    this.search();
  }

  search(): void {
    if(!this.filterWarehouse && this.searchParcelCode == '' && this.searchLoadingListCode == '') {
      this.filterWarehouseInvalid = true;
      this.filteredLists = [];
      this.lists = [];
          this.selectedIds.clear();
          this.currentPage = 1;
          this.updatePagedLists();
          this.updateSummary();
      return;
    }

    this.filterWarehouseInvalid = false;
    this.appliedWarehouse = this.filterWarehouse;

    this.isSearchLoading = true;
    this.isLoading = true;
    let clientsBrands: ClientsBrands[] = [];

    const stored = localStorage.getItem('userFunctions');
    if(stored) {
      const parsed = JSON.parse(stored);
      clientsBrands = parsed.clients;
    }
    
    const payload: any = {
      warehouseCode: this.filterWarehouse || null,
      status: this.filterStatus || null,
      dateStart: this.selectedDateFromStr || null,
      dateEnd: this.selectedDateToStr || null,
      clients: clientsBrands,
      loadingListCode: this.searchLoadingListCode || null,
      warehouseFromCode: this.filterWarehouseFrom || null,
      warehouseToCode: this.filterWarehouseTo || null,
      parcelCode: this.searchParcelCode || null
    };

    this.loadingListService.searchLoadingLists(payload)
      .pipe(finalize(() => {
        this.isSearchLoading = false;
        this.isLoading = false;
      }))
      .subscribe({
        next: (res: LoadingLists[]) => {
          this.lists = (res || []).map(ll => ({
            ...ll,
            uiType: this.getLoadingListType(ll) // 'DEPARTURE' | 'ARRIVAL'
          }));

          this.applyFrontendFilters();
          // this.lists = res || [];
          // this.filteredLists = [...this.lists];
          // this.selectedIds.clear();
          // this.currentPage = 1;
          // this.updatePagedLists();
          // this.updateSummary();
        },
        error: (err) => {
          const message = this.errorHelperService.extractBackendMessage(err);
          this.notificationService.error(`Errore: ${message}`);
          this.lists = [];
          this.filteredLists = [];
          this.selectedIds.clear();
          this.updatePagedLists();
          this.updateSummary();
        }
      });
  }

applyFrontendFilters(): void {
  const type = this.filterType ?? null;

  const base = this.lists.filter(ll => {
    const llType = (ll as any).uiType ?? this.getLoadingListType(ll);
    const okType = type === 'ALL_NO_LINE_CHECK'
      ? llType !== 'LINE_CHECK'
      : (!type || llType === type);
    return okType;
  });

  this.filteredBaseLists = base;

  this.buildFilterValues(this.filteredBaseLists);

  this.applyAll();
}


  private updatePagedLists(): void {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.pagedLists = this.filteredLists.slice(start, end);
  }

  setItemsPerPage(n: number): void {
    this.itemsPerPage = n;
    this.currentPage = 1;
  }

  onPageChange(page: number): void {
    const totalPages = this.getTotalPages();
    if (page < 1 || page > totalPages) return;
    this.currentPage = page;
    this.updatePagedLists();
  }

  getTotalPages(): number {
    return Math.max(1, Math.ceil(this.filteredLists.length / this.itemsPerPage));
  }

  getPageNumbers(): number[] {
    // semplice (1..N). Se vuoi la tua logica “finestra” come shipment, la copiamo identica dopo.
    const total = this.getTotalPages();
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  trackByPageNumber(index: number, page: number): number {
    return page;
  }

  toggleSelection(id: number): void {
    if (this.selectedIds.has(id)) this.selectedIds.delete(id);
    else this.selectedIds.add(id);
  }

  isSelected(id: number): boolean {
    return this.selectedIds.has(id);
  }

  selectAll(): void {
    // seleziona SOLO quelli nella pagina corrente? o tutti filtrati?
    // Qui: tutti filtrati (come gestione massiva)
    this.filteredLists.forEach(x => this.selectedIds.add(x.loadingListId));
  }

  deselectAll(): void {
    this.selectedIds.clear();
  }

  areAllSelected(): boolean {
    return this.filteredLists.length > 0
      && this.filteredLists.every(x => this.selectedIds.has(x.loadingListId));
  }

  printSelectedLinkedTransportDocuments(): void {
    if (this.selectedIds.size === 0 || this.isPrinting) return;

    const selected = this.lists.filter(ll => this.selectedIds.has(ll.loadingListId));

    const withoutTrip = selected.filter(ll => !ll.loadingListTripId);
    if (withoutTrip.length) {
      this.notificationService.error(
        `Borderò senza viaggio abbinato, nessun documento da scaricare: ${withoutTrip.map(ll => ll.loadingListCode).join(', ')}`
      );
    }

    const byTrip = new Map<number, LoadingLists[]>();
    selected
      .filter(ll => !!ll.loadingListTripId)
      .forEach(ll => {
        const tripId = Number(ll.loadingListTripId);
        byTrip.set(tripId, [...(byTrip.get(tripId) ?? []), ll]);
      });

    if (byTrip.size === 0) return;

    this.isPrinting = true;

    from(Array.from(byTrip.values())).pipe(
      concatMap(group =>
        this.loadingListService.downloadLinkedTransportDocuments(
          group.map(ll => ll.loadingListId),
          this.linkedDocsFallbackFileName(group[0].loadingListTripCode, group.map(ll => ll.loadingListCode))
        ).pipe(
          catchError(err => {
            const message = this.errorHelperService.extractBackendMessage(err);
            this.notificationService.error(
              `Viaggio ${group[0].loadingListTripCode ?? ''} (borderò ${group.map(ll => ll.loadingListCode).join(', ')}): ${message}`
            );
            return EMPTY;
          })
        )
      ),
      finalize(() => (this.isPrinting = false))
    ).subscribe();
  }

  exportSelected(): void {
    if (this.selectedIds.size === 0 || this.isExporting) return;

    this.isExporting = true;

    try {
      // Prendo gli elementi selezionati tra quelli filtrati (non solo la pagina)
      const selectedLists = this.filteredLists
        .filter(ll => this.selectedIds.has(ll.loadingListId));

      const exportData = selectedLists.map((ll, idx) => {
      const colli = this.buildColliColumns(ll);

      return {
        '#': idx + 1,
        'Tipo': this.getLoadingListTypeMeta(ll).label,
        'Codice': ll.loadingListCode ?? '',

        'Creato il': ll.loadingListCreatedAt ? this.formatDateTime(ll.loadingListCreatedAt) : '',
        'Creato da': ll.loadingListCreatedBy ?? '',
        'Partito il': ll.loadingListValidatedAt ? this.formatDateTime(ll.loadingListValidatedAt) : '',
        'Vettore': this.getCarrierName(ll.loadingListCarrierCode) ?? '',
        'Targa': ll.loadingListPlateNo ?? '',
        'Magazzino di partenza': this.getWarehouseName(ll.loadingListWarehouseCode) ?? '',
        'Magazzino di arrivo': ll.loadingListWarehousesToName || '',
        'Magazzino di arrivo (ABBR.)': ll.loadingListWarehousesToShortName || '',
        'Stato': this.getLoadingListStatusLabel(ll.loadingListStatus) ?? '',

        'Colli (Caricati/Scaricati)': colli.label,
        'Colli (n.)': colli.shown,
        'Colli totali (n.)': colli.total,
        'Percentuale (%)': colli.pct,
        'Peso (kg)': colli.kg,
        'Volume (m³)': colli.m3,

        'EXTRA': ll.loadingListIsExtra === 'Y' ? 'Sì' : 'No',
        'PTV': !ll.loadingListIsInternal ? 'Sì' : 'No'
      };
    });

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
      const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

      const blobData = new Blob([excelBuffer], { type: 'application/octet-stream' });

      const now = new Date();
      const timestamp = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now.getSeconds().toString().padStart(2, '0')}`;

      FileSaver.saveAs(blobData, `bordero_selezionati_${timestamp}.xlsx`);
    } finally {
      this.isExporting = false;
    }
  }

  private buildColliColumns(ll: any): {
    label: string;
    shown: number;
    total: number;
    pct: number;
    kg: number | string;
    m3: number | string;
  } {
    const label = ll.uiType === 'ARRIVAL' ? 'SCARICATI'
      : ll.uiType === 'LINE_CHECK' ? 'CONTROLLATI'
      : 'CARICATI';

    const shown = this.getShownCount(ll) ?? 0;
    const total = ll.loadingListItemsCount ?? 0;
    const pct = total > 0 ? this.getPercent(shown, total) : 0;

    const kg = this.round2(this.getShownWeight(ll));
    const m3 = this.round3(this.getShownVolume(ll));

    return { label, shown, total, pct, kg, m3 };
  }

  private round2(v: any): number | string {
    const n = Number(v);
    return isFinite(n) ? Math.round(n * 100) / 100 : '';
  }
  private round3(v: any): number | string {
    const n = Number(v);
    return isFinite(n) ? Math.round(n * 1000) / 1000 : '';
  }

  private formatDateTime(value: any): string {
    const d = new Date(value);
    if (isNaN(d.getTime())) return '';

    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear().toString().slice(2)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

  private downloadBlob(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  private nowStamp(): string {
    const d = new Date();
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const hh = String(d.getHours()).padStart(2, '0');
    const mi = String(d.getMinutes()).padStart(2, '0');
    return `${yyyy}${mm}${dd}_${hh}${mi}`;
  }

  openDetail(ll: LoadingLists): void {
    const isLineCheck = (ll.loadingListKind || '').toUpperCase() === 'LINE_CHECK';

    const dialogRef = this.dialog.open(NewLoadingListDialogComponent, {
      width: '1050px',
      maxWidth: '95vw',
      panelClass: 'app-popup-dialog',
      autoFocus: false,
      data: { mode: 'EDIT', loadingList: ll, warehouses: this.warehouses, carriers: this.carriers, tourGroups: ll.loadingListTourRoutingGroups, myWarehouseCode: this.appliedWarehouse, readOnly: isLineCheck }
    });


    dialogRef.afterClosed().subscribe((result) => {
      if (!result || isLineCheck) return;

      this.loadingListService.updateBordero(result).subscribe({
        next: () => this.search(),
        error: (err) => {
          const message = this.errorHelperService.extractBackendMessage(err);
          this.notificationService.error(`Errore: ${message}`);
        }
      });
    });
  }



  closeDetail(): void {
    this.isDetailVisible = false;
    this.selectedLoadingList = null;
  }

getLoadingListStatusStyle(status?: string): any {
  switch ((status || '').toLowerCase()) {
    case 'draft':
      return { backgroundColor: 'rgba(245, 121, 6, 0.10)', color: '#f57906' };

    case 'validated':
    case 'prepared': 
      return { backgroundColor: 'rgba(41, 122, 245, 0.10)', color: '#297af5' }; 

    case 'arrived':
      case 'arriving':
      return { backgroundColor: 'rgba(13, 202, 240, 0.10)', color: '#0dcaf0' }; // info

    case 'closed':
      return { backgroundColor: 'rgba(25, 135, 84, 0.10)', color: '#198754' }; // primary

    case 'deleted':
      return { backgroundColor: 'rgba(220, 53, 69, 0.15)', color: '#dc3545' }; // danger

    default:
      return { backgroundColor: 'rgba(108, 117, 125, 0.15)', color: '#6c757d' }; // secondary
  }
}


getLoadingListStatusLabel(status?: string): string {
  switch ((status || '').toUpperCase()) {
    case 'DRAFT':
      return 'BOZZA';

    case 'PREPARED': 
      return 'PREPARATO';

    case 'ARRIVED': 
      return 'ARRIVATO';
    case 'ARRIVING': 
      return 'IN ARRIVO';

    case 'CLOSED':
      return 'CHIUSO';

    case 'DELETED':
      return 'ELIMINATO';

    default:
      return status || 'UNKNOWN';
  }
}


getLoadingListType(ll: any): 'DEPARTURE' | 'ARRIVAL' | 'LINE_CHECK' {
  if ((ll?.loadingListKind || '').toString().trim().toUpperCase() === 'LINE_CHECK') {
    return 'LINE_CHECK';
  }

  const wh = (ll?.loadingListWarehouseCode || '').toString().trim().toLowerCase();
  const filtered = (this.appliedWarehouse || '').toString().trim().toLowerCase();

  return wh && filtered && wh === filtered ? 'DEPARTURE' : 'ARRIVAL';
}


getLoadingListTypeMeta(ll: any): { label: string; icon: string; color: string; bg: string } {
  const type = this.getLoadingListType(ll);

  if (type === 'LINE_CHECK') {
    return {
      label: 'CONTROLLO FILA',
      icon: 'fa-list-check',
      color: '#fd7e14',
      bg: 'rgba(253, 126, 20, 0.12)'
    };
  }

  if (type === 'DEPARTURE') {
    return {
      label: 'PARTENZA',
      icon: 'fa-arrow-up',
      color: '#6f42c1',
      bg: 'rgba(111, 66, 193, 0.12)'
    };
  }

  return {
    label: 'ARRIVO',
    icon: 'fa-arrow-down',
    color: '#20c997',
    bg: 'rgba(32, 201, 151, 0.12)'
  };
}



  getWarehouseName(code?: string): string {
    if (!code) return '';
    const wh = this.warehouses.find(w => w.warehouseCode === code);
    return wh ? (wh.warehouseName ?? wh.warehouseCode) : code;
  }

  getWarehouseShortName(code?: string): string {
    if (!code) return '';
    const wh = this.warehouses.find(w => w.warehouseCode === code);
    return wh ? (wh.warehouseShortName ?? wh.warehouseCode) : code;
  }

  formatRatio(done?: number, total?: number): string {
    const d = done ?? 0;
    const t = total ?? 0;
    return `${d}/${t}`;
  }

  hasLoadedMetrics(ll: LoadingLists): boolean {
    return (ll.loadingListLoadedWeight ?? 0) > 0 || (ll.loadingListLoadedVolume ?? 0) > 0;
  }

  hasUnloadedMetrics(ll: LoadingLists): boolean {
    return (ll.loadingListUnloadedWeight ?? 0) > 0 || (ll.loadingListUnloadedVolume ?? 0) > 0;
  }

  formatKg(value?: number): string {
    const v = value ?? 0;
    return `${v.toLocaleString('it-IT', { maximumFractionDigits: 1, minimumFractionDigits: 0 })} kg`;
  }

  formatM3(value?: number): string {
    const v = value ?? 0;
    return `${v.toLocaleString('it-IT', { maximumFractionDigits: 2, minimumFractionDigits: 0 })} m³`;
  }

  getPercent(done?: number, total?: number): number {
    const d = done ?? 0;
    const t = total ?? 0;
    if (t <= 0) return 0;
    return Math.max(0, Math.min(100, Math.round((d / t) * 100)));
  }

  private metricForCard(ll: LoadingLists): { items: number; weight: number; volume: number } {
  const status = (ll.loadingListStatus ?? '').toUpperCase();

  const itemsCount = ll.loadingListItemsCount ?? 0;

  const loadedItems = ll.loadingListLoadedCount ?? 0;
  const loadedWeight = ll.loadingListLoadedWeight ?? 0;
  const loadedVolume = ll.loadingListLoadedVolume ?? 0;

  const unloadedItems = ll.loadingListUnloadedCount ?? 0;
  const unloadedWeight = ll.loadingListUnloadedWeight ?? 0;
  const unloadedVolume = ll.loadingListUnloadedVolume ?? 0;

  if (status === 'DRAFT') {
    const pendingItems = Math.max(0, itemsCount - loadedItems);
    return { items: pendingItems, weight: 0, volume: 0 };
  }

  if (status === 'PREPARED') {
    return { items: loadedItems, weight: loadedWeight, volume: loadedVolume };
  }

  if (status === 'ARRIVED' || status === 'ARRIVING') {
    return { items: unloadedItems, weight: unloadedWeight, volume: unloadedVolume };
  }

  if (status === 'CLOSED') {
    // CLOSED = UNLOADED
    return { items: unloadedItems, weight: unloadedWeight, volume: unloadedVolume };
  }

  return { items: 0, weight: 0, volume: 0 };
}


  updateSummary(): void {
  const list = this.filteredLists ?? [];
  const s = (v?: string) => (v ?? '').toUpperCase();

  const sumMetric = (arr: LoadingLists[]) => arr.reduce(
    (acc, x) => {
      const m = this.metricForCard(x);
      acc.items += m.items;
      acc.weight += m.weight;
      acc.volume += m.volume;
      return acc;
    },
    { items: 0, weight: 0, volume: 0 }
  );

  // Conteggi card
  this.summaryTotal = list.length;
  this.summaryDraft = list.filter(x => s(x.loadingListStatus) === 'DRAFT').length;
  this.summaryValidated = list.filter(x => s(x.loadingListStatus) === 'PREPARED').length;
  this.summaryArrived = list.filter(x => s(x.loadingListStatus) === 'ARRIVED' || s(x.loadingListStatus) === 'ARRIVING').length;
  this.summaryClosed = list.filter(x => s(x.loadingListStatus) === 'CLOSED').length;

  const d = sumMetric(list.filter(x => s(x.loadingListStatus) === 'DRAFT'));
  this.totDraftItems = d.items;
  this.totDraftWeight = d.weight;
  this.totDraftVolume = d.volume;

  const p = sumMetric(list.filter(x => s(x.loadingListStatus) === 'PREPARED'));
  this.totPreparedItems = p.items;
  this.totPreparedWeight = p.weight;
  this.totPreparedVolume = p.volume;

  const a = sumMetric(list.filter(x => s(x.loadingListStatus) === 'ARRIVED' || s(x.loadingListStatus) === 'ARRIVING'));
  this.totArrivedItems = a.items;
  this.totArrivedWeight = a.weight;
  this.totArrivedVolume = a.volume;

  const c = sumMetric(list.filter(x => s(x.loadingListStatus) === 'CLOSED'));
  this.totClosedItems = c.items;
  this.totClosedWeight = c.weight;
  this.totClosedVolume = c.volume;
}


  
  toggleReportCollapsed(): void {
    this.isReportCollapsed = !this.isReportCollapsed;
  }

  getCarrierName(code?: string): string {
    if (!code) return '';
    const c = this.carriers.find(c => c.carrierCode === code);
    return c ? c.carrierName : code;
  }

  isArrived(status: any): boolean {
    return status === 'ARRIVED' || status === 'ARRIVATO' || status === 'ARRIVING';
  }

  getShownCount(ll: any): number {
    return ll.uiType == 'ARRIVAL'
      ? (ll.loadingListUnloadedCount ?? 0)
      : (ll.loadingListLoadedCount ?? 0);
  }

  getShownWeight(ll: any): number {
    return ll.uiType == 'ARRIVAL'
      ? (ll.loadingListUnloadedWeight ?? 0)
      : (ll.loadingListLoadedWeight ?? 0);
  }

  getShownVolume(ll: any): number {
    return ll.uiType == 'ARRIVAL'
      ? (ll.loadingListUnloadedVolume ?? 0)
      : (ll.loadingListLoadedVolume ?? 0);
  }

  isDropdownOpen(id: string | number): boolean {
    return this.openDropdownId  === id;
  }

  // toggleDropdown(id: string | number, event?: MouseEvent): void {
  //   event?.stopPropagation();

  //   this.openedDropdownId = (this.openedDropdownId === id) ? null : id;
  // }

  closeAllDropdowns(): void {
    this.openDropdownId  = null;
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.closeAllDropdowns();
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.closeAllDropdowns();
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.closeAllDropdowns();
  }

  printLinkedTransportDocuments(ll: LoadingLists): void {
    if (!ll.loadingListTripId) {
      this.notificationService.error(`Il borderò ${ll.loadingListCode} non è abbinato a nessun viaggio`);
      return;
    }
    this.downloadLinkedTransportDocuments([ll.loadingListId], ll.loadingListTripCode, [ll.loadingListCode]);
  }

  private downloadLinkedTransportDocuments(loadingListIds: number[], tripCode: string | null | undefined, loadingListCodes: string[]): void {
    this.isPrinting = true;

    this.loadingListService.downloadLinkedTransportDocuments(
      loadingListIds,
      this.linkedDocsFallbackFileName(tripCode, loadingListCodes)
    )
      .pipe(finalize(() => (this.isPrinting = false)))
      .subscribe({
        error: (err) => {
          const message = this.errorHelperService.extractBackendMessage(err);
          this.notificationService.error(`Errore: ${message}`);
        }
      });
  }

  private linkedDocsFallbackFileName(tripCode: string | null | undefined, loadingListCodes: string[]): string {
    return `DocTrasporto_V${tripCode ?? 'NA'}_B${loadingListCodes.join('-')}_${this.nowStamp()}.pdf`;
  }

openDeletePopup(ll: any): void {
  this.deleteTarget = ll;
  this.deleteConfirmText = '';
  this.showDeletePopup = true;
}

closeDeletePopup(): void {
  if (this.deleting) return; // evita chiusura mentre elimina (se vuoi)
  this.showDeletePopup = false;
  this.deleteTarget = null;
}

confirmDeletePopup(): void {
  if (!this.deleteTarget) return;

  this.deleting = true;

  this.loadingListService.deleteLoadingList(this.deleteTarget.loadingListId)
    .subscribe({
      next: () => {
        this.deleting = false;
        this.closeDeletePopup();
        this.search();
        this.notificationService.success('Borderò eliminato con successo');
      },
      error: (err) => {
        this.deleting = false;
        const message = this.errorHelperService.extractBackendMessage(err);
        this.notificationService.error(`Errore: ${message}`);
      }
    });
}

sortState = { active: '', direction: 'asc' as 'asc' | 'desc' };

filtersOpen: Record<string, boolean> = {};
filterSearch: Record<string, string> = {};
filterSelected: Record<string, Set<string>> = {};
filterValuesAll: Record<string, string[]> = {};
filterValuesShown: Record<string, string[]> = {};

private filteredBaseLists: LoadingLists[] = [];

setSort(col: string) {
  if (this.sortState.active === col) {
    this.sortState.direction = this.sortState.direction === 'asc' ? 'desc' : 'asc';
  } else {
    this.sortState.active = col;
    this.sortState.direction = 'asc';
  }
  this.applyAll();
}

getSortIcon(col: string) {
  if (this.sortState.active !== col) return 'bi-arrow-down-up';
  return this.sortState.direction === 'asc' ? 'bi-arrow-up' : 'bi-arrow-down';
}

toggleFilterPopup(col: string, ev?: Event) {
  ev?.stopPropagation();
  Object.keys(this.filtersOpen).forEach(k => this.filtersOpen[k] = false);
  this.filtersOpen[col] = !this.filtersOpen[col];

  if (this.filtersOpen[col]) {
    this.rebuildFilterList(col);
  }
}

closeAllPopups() {
  Object.keys(this.filtersOpen).forEach(k => this.filtersOpen[k] = false);
}

rebuildFilterList(col: string) {
  const s = (this.filterSearch[col] || '').trim().toLowerCase();
  const all = this.filterValuesAll[col] || [];
  this.filterValuesShown[col] = !s ? all : all.filter(v => v.toLowerCase().includes(s));
}

toggleFilterValue(col: string, value: string, checked: boolean) {
  if (!this.filterSelected[col]) this.filterSelected[col] = new Set<string>();
  if (checked) this.filterSelected[col].add(value);
  else this.filterSelected[col].delete(value);
}

isValueSelected(col: string, value: string) {
  return this.filterSelected[col]?.has(value) ?? false;
}

onToggleAll(col: string, checked: boolean) {
  if (!this.filterSelected[col]) this.filterSelected[col] = new Set<string>();
  this.filterSelected[col].clear();

  if (checked) {
    (this.filterValuesAll[col] || []).forEach(v => this.filterSelected[col].add(v));
  }
}

resetFilter(col: string) {
  this.filterSelected[col] = new Set<string>();
  this.filterSearch[col] = '';
  this.rebuildFilterList(col);
  this.applyAll();
}

applyFilter(col: string) {
  this.applyAll();
  this.filtersOpen[col] = false;
}

private getCreatedByUi(ll: LoadingLists): string {
  return ll.loadingListCreatedBy === 'SPARE PARTS' ? 'Spare Parts' : 'Atlas';
}

private initFilterState(cols: string[]) {
  cols.forEach(col => {
    if (!this.filterSelected[col]) this.filterSelected[col] = new Set<string>();
    if (!this.filterSearch[col]) this.filterSearch[col] = '';
    if (!this.filterValuesAll[col]) this.filterValuesAll[col] = [];
    if (!this.filterValuesShown[col]) this.filterValuesShown[col] = [];
    if (!this.filtersOpen[col]) this.filtersOpen[col] = false;
  });
}

buildFilterValues(source: LoadingLists[]) {
  const uniq = (arr: string[]) =>
    Array.from(new Set(arr.map(x => (x ?? '').toString().trim()).filter(x => x !== ''))).sort();

  const cols = ['type', 'code', 'createdByUi', 'carrier', 'plate', 'warehouse', 'warehouseTo', 'status', 'extra', 'ptv'];
  this.initFilterState(cols);

  const map: Record<string, (ll: LoadingLists) => string> = {
    type: (ll) => this.getLoadingListTypeMeta(ll).label,
    code: (ll) => (ll.loadingListCode ?? '').toString(),
    createdByUi: (ll) => this.getCreatedByUi(ll),
    carrier: (ll) => this.getCarrierName(ll.loadingListCarrierCode) || '',
    plate: (ll) => (ll.loadingListPlateNo ?? '').toString(),
    warehouse: (ll) => this.getWarehouseName(ll.loadingListWarehouseCode) || '',
    warehouseTo: (ll) => ll.loadingListWarehousesToName + '---------------' + ll.loadingListWarehousesToShortName || '',
    status: (ll) => this.getLoadingListStatusLabel(ll.loadingListStatus) || '',
    extra: (ll) => (ll.loadingListIsExtra === 'Y' ? 'Sì' : 'No'),
    ptv: (ll) => (!ll.loadingListIsInternal ? 'Sì' : 'No'),
  };

  cols.forEach(col => {
    this.filterValuesAll[col] = uniq(source.map(map[col]));
    this.filterValuesShown[col] = [...this.filterValuesAll[col]];
  });
}

applyAll() {
  let arr = [...this.filteredBaseLists];

  const getVal: Record<string, (ll: LoadingLists) => string> = {
    type: (ll) => this.getLoadingListTypeMeta(ll).label,
    code: (ll) => (ll.loadingListCode ?? '').toString(),
    createdByUi: (ll) => this.getCreatedByUi(ll),
    carrier: (ll) => this.getCarrierName(ll.loadingListCarrierCode) || '',
    plate: (ll) => (ll.loadingListPlateNo ?? '').toString(),
    warehouse: (ll) => this.getWarehouseName(ll.loadingListWarehouseCode) || '',
    status: (ll) => this.getLoadingListStatusLabel(ll.loadingListStatus) || '',
    extra: (ll) => (ll.loadingListIsExtra === 'Y' ? 'Sì' : 'No'),
    ptv: (ll) => (!ll.loadingListIsInternal ? 'Sì' : 'No'),
  };

  Object.keys(getVal).forEach(col => {
    const sel = this.filterSelected[col];
    if (sel && sel.size > 0) {
      arr = arr.filter(ll => sel.has(getVal[col](ll)));
    }
  });

  if (this.sortState.active) {
    const col = this.sortState.active;
    const dir = this.sortState.direction;

    const getter: Record<string, (ll: LoadingLists) => any> = {
      type: (ll) => this.getLoadingListTypeMeta(ll).label,
      code: (ll) => ll.loadingListCode ?? '',
      createdAt: (ll) => ll.loadingListCreatedAt ?? null,
      createdByUi: (ll) => this.getCreatedByUi(ll),
      validatedAt: (ll) => ll.loadingListValidatedAt ?? null,
      carrier: (ll) => this.getCarrierName(ll.loadingListCarrierCode) || '',
      plate: (ll) => ll.loadingListPlateNo ?? '',
      warehouse: (ll) => this.getWarehouseName(ll.loadingListWarehouseCode) || '',
      status: (ll) => this.getLoadingListStatusLabel(ll.loadingListStatus) || '',
      extra: (ll) => (ll.loadingListIsExtra === 'Y' ? 1 : 0),
      ptv: (ll) => (!ll.loadingListIsInternal ? 1 : 0),
    };

    const g = getter[col] || ((x: any) => x[col]);

    arr.sort((a, b) => {
      const va = g(a);
      const vb = g(b);

      if (va == null && vb == null) return 0;
      if (va == null) return dir === 'asc' ? -1 : 1;
      if (vb == null) return dir === 'asc' ? 1 : -1;

      const da = col === 'createdAt' || col === 'validatedAt' ? new Date(va).getTime() : NaN;
      const db = col === 'createdAt' || col === 'validatedAt' ? new Date(vb).getTime() : NaN;
      if (!isNaN(da) && !isNaN(db)) return dir === 'asc' ? da - db : db - da;

      const sa = ('' + va).toLowerCase();
      const sb = ('' + vb).toLowerCase();
      if (sa < sb) return dir === 'asc' ? -1 : 1;
      if (sa > sb) return dir === 'asc' ? 1 : -1;
      return 0;
    });
  }

  this.filteredLists = arr;
  this.selectedIds.clear();
  this.currentPage = 1;
  this.updatePagedLists();
  this.updateSummary();
}

isFirstRowDropdownOpen(): boolean {
  if (!this.filteredLists || this.filteredLists.length === 0) {
    return false;
  }

  const start = (this.currentPage - 1) * this.itemsPerPage;
  const firstOfPage = this.filteredLists[start];
  if (!firstOfPage) return false;

  return this.isDropdownOpen(firstOfPage.loadingListId);
}

toggleDropdown(id: number, event: MouseEvent): void {
  event.stopPropagation();

  if (this.openDropdownId === id) {
    this.openDropdownId = null;
    return;
  }

  const button = event.currentTarget as HTMLElement;
  const rect = button.getBoundingClientRect();

  const menuWidth = 188;
  const menuHeight = 108;
  const gap = 6;

  let left = rect.right - menuWidth;
  let top = rect.top - menuHeight - gap;

  if (left < 8) {
    left = 8;
  }

  if (top < 8) {
    top = rect.bottom + gap;
  }

  this.dropdownStyles[id] = {
    top: `${top}px`,
    left: `${left}px`
  };

  this.openDropdownId = id;
}

getDropdownStyle(id: number): any {
  return this.dropdownStyles[id] || {};
}

  openInvalidateParcelsPopup(): void {
    const dialogRef = this.dialog.open(LoadingListInvalidateDialogComponent, {
      width: '1050px',
      maxWidth: '95vw',
      panelClass: 'app-popup-dialog',
      autoFocus: false,
      data: {
        warehouses: this.warehouses
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) return;

      this.isLoading = true;

      this.loadingListService
        .invalidateParcelsForLoadingLists(result.parcelCodes, result.isToInvalid)
        .pipe(finalize(() => (this.isLoading = false)))
        .subscribe({
          next: () => {
            this.notificationService.success(
              result.isToInvalid
                ? `${result.parcelCodes.length} colli invalidati con successo`
                : `${result.parcelCodes.length} colli rivalidati con successo`
            );
          },
          error: (err) => {
            const message = this.errorHelperService.extractBackendMessage(err);
            this.notificationService.error(`Errore: ${message}`);
          }
        });
    });
  }

  printDDT(id: number): void {
    const ids: number[] = [id];


    this.loadingListService.printDDTFromLoadingLists(ids)
      .subscribe({
        next: (blob: Blob) => this.downloadBlob(blob, `DDT_${this.nowStamp()}.pdf`),
        error: (err) => {
          const message = this.errorHelperService.extractBackendMessage(err);
          this.notificationService.error(`Errore: ${message}`);
        }
      });
  }

  
  printSelectedDDT(): void {
    const ids = Array.from(this.selectedIds);
    if (ids.length === 0) return;

    ids.forEach(id => {
      this.loadingListService.printDDTFromLoadingLists(ids)
        .subscribe({
          next: (blob: Blob) => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `DDT_${id}_${this.nowStamp()}.pdf`;
            link.click();
            window.URL.revokeObjectURL(url);
          },
          error: (err) => {
            const message = this.errorHelperService.extractBackendMessage(err);
            this.notificationService.error(`Errore: ${message}`);
          }
        });
    });
  }
  
  searchWarehouseFn(term: string, item: any): boolean {
    const t = term.toLowerCase();
    return (
      item.warehouseName?.toLowerCase().includes(t) ||
      item.warehouseShortName?.toLowerCase().includes(t) ||
      item.warehouseCode?.toLowerCase().includes(t)
    );
  }

  onWarehouseChange(): void {
    if (this.filterWarehouse) {
      this.filterWarehouseInvalid = false;
    }
  }

      setLoadingListsItemsPerPage(n: number): void {
        this.itemsPerPage = n;
        this.currentPage = 1;
        this.applyAll();
    }

    onLoadingListsPageChange(page: number): void {
        const total = Math.max(1, Math.ceil(this.filteredLists.length / this.itemsPerPage));

        if (page < 1 || page > total) return;

        this.currentPage = page;
        //this.applyAll();
    }

    trackByLoadingListId(index: number, p: any): number {
        return p?.parcelComplementaryId ?? index;
    }

}